import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "messenger-panel"
}
const _hoisted_2 = { class: "msg-header" }
const _hoisted_3 = { class: "msg-header-title" }
const _hoisted_4 = {
  key: 0,
  class: "msg-view"
}
const _hoisted_5 = {
  key: 0,
  class: "msg-empty"
}
const _hoisted_6 = {
  key: 1,
  class: "msg-empty"
}
const _hoisted_7 = {
  key: 2,
  class: "conv-list"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "conv-avatar" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "conv-avatar-initials"
}
const _hoisted_12 = { class: "conv-info" }
const _hoisted_13 = { class: "conv-name-row" }
const _hoisted_14 = { class: "conv-name" }
const _hoisted_15 = { class: "conv-time" }
const _hoisted_16 = { class: "conv-preview-row" }
const _hoisted_17 = { class: "conv-preview" }
const _hoisted_18 = {
  key: 0,
  class: "conv-preview-me"
}
const _hoisted_19 = {
  key: 0,
  class: "conv-unread"
}
const _hoisted_20 = { class: "msg-footer" }
const _hoisted_21 = {
  key: 1,
  class: "msg-view"
}
const _hoisted_22 = { class: "new-search-wrap" }
const _hoisted_23 = {
  key: 0,
  class: "msg-empty"
}
const _hoisted_24 = {
  key: 1,
  class: "msg-empty"
}
const _hoisted_25 = {
  key: 2,
  class: "user-list"
}
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = { class: "conv-avatar" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "conv-avatar-initials"
}
const _hoisted_30 = { class: "user-info" }
const _hoisted_31 = { class: "user-name" }
const _hoisted_32 = { class: "user-username" }
const _hoisted_33 = {
  key: 2,
  class: "msg-view chat-view"
}
const _hoisted_34 = {
  class: "chat-messages",
  ref: "chatMessagesEl"
}
const _hoisted_35 = {
  key: 0,
  class: "msg-empty"
}
const _hoisted_36 = {
  key: 1,
  class: "msg-empty"
}
const _hoisted_37 = { class: "chat-bubble" }
const _hoisted_38 = { class: "bubble-time" }
const _hoisted_39 = { class: "chat-input-wrap" }
const _hoisted_40 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "messenger-slide" }, {
    default: _withCtx(() => [
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.view !== 'list')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "msg-back",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M15 18l-6-6 6-6" })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.view === 'list' ? 'Mensagens' : _ctx.view === 'new' ? 'Nova conversa' : _ctx.activeConvName), 1),
              _createElementVNode("button", {
                class: "msg-close",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M18 6L6 18M6 6l12 12" })
                ], -1)
              ]))])
            ]),
            (_ctx.view === 'list')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.messengerStore.state.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Carregando..."))
                    : (_ctx.messengerStore.state.conversations.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" Nenhuma conversa ainda.", -1),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode("Clique em \"Nova conversa\" para começar. ", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messengerStore.state.conversations, (conv) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: conv.id,
                              class: "conv-item",
                              type: "button",
                              onClick: ($event: any) => (_ctx.openConversation(conv))
                            }, [
                              _createElementVNode("div", _hoisted_9, [
                                (conv.otherAvatar && conv.otherAvatar.startsWith('/uploads/'))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _ctx.resolveAvatar(conv.otherAvatar),
                                      alt: "avatar"
                                    }, null, 8, _hoisted_10))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.initials(conv.otherName)), 1))
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(conv.otherName), 1),
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatTime(conv.lastMessageAt)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("span", _hoisted_17, [
                                    (conv.lastMessageBy === _ctx.currentUsername)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Você: "))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(conv.lastMessageText || 'Sem mensagens'), 1)
                                  ]),
                                  (conv.unreadCount > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(conv.unreadCount > 9 ? '+9' : conv.unreadCount), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ], 8, _hoisted_8))
                          }), 128))
                        ])),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "btn-new-conv",
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openNewConv && _ctx.openNewConv(...args)))
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("svg", {
                        width: "15",
                        height: "15",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                      ], -1),
                      _createTextVNode(" Nova conversa ", -1)
                    ]))])
                  ])
                ]))
              : (_ctx.view === 'new')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userSearch) = $event)),
                        class: "new-search",
                        type: "text",
                        placeholder: "Buscar por nome ou username...",
                        autofocus: ""
                      }, null, 512), [
                        [_vModelText, _ctx.userSearch]
                      ])
                    ]),
                    (_ctx.loadingUsers)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Carregando usuários..."))
                      : (_ctx.filteredUsers.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Nenhum usuário encontrado."))
                        : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (u) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: u.username,
                                class: "user-item",
                                type: "button",
                                onClick: ($event: any) => (_ctx.startConversation(u.username)),
                                disabled: _ctx.startingConv
                              }, [
                                _createElementVNode("div", _hoisted_27, [
                                  (u.avatar && u.avatar.startsWith('/uploads/'))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.resolveAvatar(u.avatar),
                                        alt: "avatar"
                                      }, null, 8, _hoisted_28))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.initials(u.name)), 1))
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("span", _hoisted_31, _toDisplayString(u.name), 1),
                                  _createElementVNode("span", _hoisted_32, "@" + _toDisplayString(u.username), 1)
                                ])
                              ], 8, _hoisted_26))
                            }), 128))
                          ]))
                  ]))
                : (_ctx.view === 'chat')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        (_ctx.messengerStore.messagesLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, "Carregando..."))
                          : (_ctx.messengerStore.activeMessages.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, " Nenhuma mensagem. Diga olá! "))
                            : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messengerStore.activeMessages.value, (msg) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: msg.id,
                            class: _normalizeClass(["chat-bubble-wrap", msg.senderUsername === _ctx.currentUsername ? 'bubble-own' : 'bubble-other'])
                          }, [
                            _createElementVNode("div", _hoisted_37, _toDisplayString(msg.text), 1),
                            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.formatTime(msg.createdAt)), 1)
                          ], 2))
                        }), 128))
                      ], 512),
                      _createElementVNode("div", _hoisted_39, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputText) = $event)),
                          class: "chat-input",
                          type: "text",
                          placeholder: "Mensagem...",
                          onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputText]
                        ]),
                        _createElementVNode("button", {
                          class: "chat-send",
                          type: "button",
                          disabled: !_ctx.inputText.trim() || _ctx.sending,
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
                        }, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("line", {
                              x1: "22",
                              y1: "2",
                              x2: "11",
                              y2: "13"
                            }),
                            _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
                          ], -1)
                        ]))], 8, _hoisted_40)
                      ])
                    ]))
                  : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}